import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/penny-arcade': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M421.9 164.3c7.3 16.3 2.3 5.1 24.6 54.7l-39.7 10.6c13.7-59.2 10.6-45.8 15.1-65.3zM215.8 215.4c32.5-9 41.9 37.6-0.4 47.4-14.2 3.8-6.6 1.8-34.8 9.3l-4.5-46.2c28.3-7.5 19.4-5.2 39.6-10.6zM542 189.2c75.8 37.9 98 76.3 98 104.5 2.1 78.8-183.3 130.3-399.9 84.8 0.5 13-8 24.6-20.6 28-125.5 33.5-117.3 31.8-122.5 31.8-14.4 0-26.4-10.9-27.8-25.2l-4.3-44.5c-0.1-0.7-0.1-1.9-0.1-2.6 0-10.6 8-22.2 17.9-26l-1.7-17.9c-50.2-28.3-80.9-61.9-80.9-95.4 0-72.9 144.3-113.4 309.4-98.4 2.7-7.5 11.2-15.3 18.9-17.4 96.9-25.9 65.3-17.5 135.6-36.2 13.2-3.5 26.9 3 32.6 15.3zM255.1 298.3c17.5-4 40.2-19.2 50.8-33.7 21.6-32.6 14.1-105.6-42.5-104.4-16 0.2-8.1-0.9-186.2 46.6l4.3 44.5 20.1-5.4 11.1 114.6-20 5.4 4.3 44.5 115.3-30.8-4.5-44.5-20.5 5.5-2.5-23.5 48.4-12.9zM454.3 314.9l108.5-29-4.3-44.5-20.8 5.6-66.7-145.5c-70.6 18.8-42.2 11.3-135.6 36.2l4.2 44.5 17.2-4.6-33.1 126.5-21 5.6 4.5 44.4 112.9-30.1-4.1-39.5-19.2 5.1 4.1-17.5 57.8-15.4 6.6 14.7-14.9 4z'
      }
    ]
  }
})
